<template>
    <div class="one-music-component"
        @click="clickOneMusic()"
        :class="{'one-music-component-active' : status}"
    >

        <div class="one-music-component__audio">
            <audio :src="audio" :id="id"></audio>
        </div>

        <div class="one-music-component__button-play"
            v-if="status && !play"
            @click.stop="clickPlay()"
        >
            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.05 6.87417C13.9167 7.37454 13.9167 8.62546 13.05 9.12583L1.95 15.5344C1.08333 16.0348 -7.60986e-07 15.4093 -7.17242e-07 14.4086L-1.56986e-07 1.59141C-1.13242e-07 0.590672 1.08333 -0.0347923 1.95 0.465578L13.05 6.87417Z" fill="white"/>
            </svg>
        </div>

        <div class="one-music-component__button-stop"
            v-if="play"
            @click.stop="clickStop()"
        >
            <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.600098" y="0.759766" width="4.46663" height="17.48" rx="0.5" fill="white"/>
                <rect x="9.5332" y="0.759766" width="4.46663" height="17.48" rx="0.5" fill="white"/>
            </svg>
        </div>

        <div class="one-music-component__title">
            {{ title }}
        </div>

        <div class="one-music-component__button-select"
            v-if="status"
            @click.stop="clickSelectMusic()"
        >
            Выбрать
        </div>

        <div class="one-music-component__button-status"
            v-if="selected && !status"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.7143 7.30469L9.28571 17.1432L5 12.6711" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            title: {
                default: ''
            },
            status: {
                default: false
            },
            index: {
                default: false
            },
            play: {
                default: false
            },
            file: {
                default: false
            },
            id: {
                default: false
            },
            selected: {
                default: false
            },
            arr: {
                default: false
            }
        },
        data() {
            return {

            }
        },
        methods: {
            async clickOneMusic() {
                this.$emit('clickOneMusic', {
                    index: this.index,
                    id: this.id
                })
            },
            async clickPlay() {
                this.$emit('clickPlay', {
                    index: this.index,
                    id: this.id
                })
            },
            async clickStop() {
                this.$emit('clickStop', {
                    index: this.index,
                    id: this.id
                })
            },
            async clickSelectMusic() {
                this.$emit('clickSelectMusic', {
                    index: this.index,
                    id: this.id,
                    arr: this.arr
                })
            }
        },
        computed: {
            audio() {
                try {
                    if(this.file) {
                        if(this.file.indexOf('http') === -1) {
                            return require('~/assets/music/' + `${this.audio}`)
                        } else {
                            return this.file
                        }
                    }
                } catch(e) {
                    console.error(e)
                    return false
                }
            }
        }
    }
</script>

<style lang="less">
    .one-music-component {
        height: 44px;
        width: 100%;
        min-width: 100%;
        display: flex;
        align-items: center;
        padding-left: 16px;
        padding-right: 120px;
        border-top: 0.5px solid rgba( 255, 255, 255, .2);
        cursor: pointer;
        position: relative;
    }

    .one-music-component__title {
        color: #FFFFFF;
        font-size: 15px;
        line-height: 20px;
        font-family: 'Roboto-Light';
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .one-music-component__button-select {
        width: 81px;
        height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Roboto-Light';
        color: #31283D;
        font-size: 13px;
        line-height: 20px;
        background: #FFFFFF;
        border-radius: 5px;
        position: absolute;
        right: 16px;
    }

    .one-music-component__button-status {
        position: absolute;
        right: 16px;
    }

    .one-music-component-active {
        background: rgba(255, 255, 255, 0.1);
    }

    .one-music-component__button-play,
    .one-music-component__button-stop {
        margin-right: 10px;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

</style>